import { Navigate, Route, Routes } from "react-router-dom";
import { allScreens } from "@/application/navigation";
import { ScreenPage } from "@/pages/ScreenPage";
import { SystemStatusPage } from "@/pages/system/SystemStatusPage";
import { InvestorHomePage } from "@/pages/investor/InvestorHomePage";
import { InvestorMyInvestmentPage } from "@/pages/investor/InvestorMyInvestmentPage";
import { AdminCompanyGeneralPage } from "@/pages/admin/AdminCompanyGeneralPage";
import { AdminCompanyLegalPage } from "@/pages/admin/AdminCompanyLegalPage";

// Some Screen-to-Data Map rows share one route (an "internal state" of the
// same page, e.g. an Ownership Overview panel inside My Investment) —
// dedupe by route so React Router only registers one <Route> per URL.
const uniqueRoutes = Array.from(new Map(allScreens.map((s) => [s.route, s])).values());

// Real, pixel-matched implementations built so far. Every other route still
// falls back to the generic foundation-phase ScreenPage placeholder.
const REAL_PAGES: Record<string, () => JSX.Element> = {
  "/investor/home": InvestorHomePage,
  "/investor/my-investment": InvestorMyInvestmentPage,
  "/admin/company": AdminCompanyGeneralPage,
  "/admin/company/legal-and-registration": AdminCompanyLegalPage,
};

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/investor/home" replace />} />
      <Route path="/system/status" element={<SystemStatusPage />} />

      {uniqueRoutes.map((screen) => {
        const RealPage = REAL_PAGES[screen.route];
        return (
          <Route
            key={screen.route}
            path={screen.route}
            element={RealPage ? <RealPage /> : <ScreenPage portal={screen.portal} />}
          />
        );
      })}

      <Route path="*" element={<Navigate to="/investor/home" replace />} />
    </Routes>
  );
}
